import {MobileIcon, Nav, NavbarContainer, NavItem, NavLinks, NavLogo, NavMenu, NavRouterLinks} from "./NavBarElements";
import {FaInstagram, FaFacebook, FaBars, FaLinkedin, FaTwitter} from "react-icons/fa"
import logo from "../../images/logo_small_navbar.jpeg"

const MyNavBar = ({toggle}) => {
    return (
        <Nav>
            <NavbarContainer>
                <NavLogo to={'/'}><img src={logo} alt="logo" /></NavLogo>
                <MobileIcon onClick={toggle}>
                    <FaBars />
                </MobileIcon>
                <NavMenu>
                    <NavItem>
                        <NavRouterLinks to='/work'>HOW IT WORKS?</NavRouterLinks>
                    </NavItem>
                    <NavItem>
                        <NavRouterLinks to='/contact'>CONTACT</NavRouterLinks>
                    </NavItem>
                    <NavItem>
                        <NavLinks href={'https://www.linkedin.com/introductable'} target="_blank" rel="noopener noreferrer">
                            <FaLinkedin />
                        </NavLinks>
                    </NavItem>
                    <NavItem>
                        <NavLinks href={'https://www.twitter.com/introductable'} target="_blank" rel="noopener noreferrer">
                            <FaTwitter />
                        </NavLinks>
                    </NavItem>
                    <NavItem>
                        <NavLinks href={'https://www.instagram.com/introductable'} target="_blank" rel="noopener noreferrer">
                            <FaInstagram />
                        </NavLinks>
                    </NavItem>
                    <NavItem>
                        <NavLinks href={'https://www.facebook.com/introductable'} target="_blank" rel="noopener noreferrer">
                            <FaFacebook />
                        </NavLinks>
                    </NavItem>
                </NavMenu>
            </NavbarContainer>
        </Nav>
    );
}

export default MyNavBar;
